import { ServiceTierActions } from "../Constants/Constants";

/**
 * @param {*} data : response from get service tier api for given device model
 * @returns Array of objects as required by service tier table
 */
export const convertServiceTierList = (data) => {
  const list = data?.servicetiers || [];
  return list.map((tier) => {
    return {
      key: tier.servicetierid,
      serviceTierId: tier.servicetierid,
      serviceTierName: tier.servicetiername,
      offeringData: {},
    };
  });
};

/**
 * @param {*} data : response from get service tier detail api for given tier id
 * @returns Array of service offering objects as required by offering subtable
 */
export const convertServiceTierOfferingData = (data) => {
  const record = data?.servicetier || {};
  const offerings = record.modelofferings || [];
  return offerings.map((item) => {
    return {
      // required fields for display
      key: record.servicetierid + ":" + item.devicemodelid + ":" + item.offerid,
      offeringName: item.offeringname,
      modelNumber: item.modelnumber,
      status: item.status,
      tierDetails: item.tierdetails,
      // extra fields for processing
      offerId: item.offerid,
      deviceModelId: item.devicemodelid,
      serviceTierId: record.servicetierid,
      serviceTierName: record.servicetiername,
    };
  });
};

/**
 * @param {*} formData : service tier form submitted values
 * @param {*} action : action type: add or edit
 * @returns Object formatted as required by create or update api
 */
export const convertServiceTierFormToApiValues = (
  formData,
  action = ServiceTierActions.add
) => {
  console.log("convertServiceTierFormToApiValues", formData);
  const returnData = {
    modelofferings: formData.serviceOfferings.map((item) => {
      return {
        offerid: item,
        devicemodelid: formData.deviceModel,
      };
    }),
  };
  if (action === ServiceTierActions.add) {
    returnData.servicetiername = formData.serviceTierName;
  }
  if (action === ServiceTierActions.edit) {
    returnData.servicetierid = formData.serviceTierId;
  }
  return returnData;
};
